import type { SupportedLocale, TranslationCatalog } from "../TranslationManager";
import { en } from "./en";
import { fr } from "./fr";
import { de } from "./de";
import { es } from "./es";
import { pt } from "./pt";
import { it } from "./it";
import { nl } from "./nl";
import { ja } from "./ja";
import { zh } from "./zh";
import { ar } from "./ar";
import { hi } from "./hi";
import { bn } from "./bn";
import { ru } from "./ru";
import { ko } from "./ko";
import { vi } from "./vi";
import { tr } from "./tr";
import { th } from "./th";
import { pl } from "./pl";
import { uk } from "./uk";
import { ms } from "./ms";
import { tl } from "./tl";
import { sw } from "./sw";
import { ta } from "./ta";
import { he } from "./he";
import { id } from "./id";

export const catalogs: Record<SupportedLocale, TranslationCatalog> = {
  en, fr, de, es, pt, it, nl, ja, zh, ar,
  hi, bn, ru, ko, vi, tr, th, pl, uk, ms, tl, sw, ta, he, id,
};
